// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import BootstrapVue from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'font-awesome/css/font-awesome.min.css'

import Vue from 'vue'
import router from './router'
import App from './App'

import jQuery from 'jquery'

global.$ = global.jQuery = jQuery

global.fail = function (xhr, display = false) {
  if (xhr.statusText === 'abort') {
    return
  }

  let error = 'Une erreur s\'est produite'
  if (xhr.responseJSON) {
    if (xhr.responseJSON.erreurs && typeof xhr.responseJSON.erreurs === 'string') {
      error = xhr.responseJSON.erreurs
    } else if (xhr.responseJSON.erreurs && xhr.responseJSON.erreurs.length) {
      error = xhr.responseJSON.erreurs.map(function (error) {
        return error.message
      }).join('<br>')
    } else if (xhr.responseJSON.exception) {
      error = xhr.responseJSON.exception.map(function (error) {
        return error.message
      }).join('<br>')
    } else if (xhr.responseJSON.message) {
      error = xhr.responseJSON.message
    }
  }

  if (display) {
    window.vm.$bvToast.toast(error, {
      title: `Oups, il y a un problème`,
      variant: 'warning',
      solid: true
    })
  }

  return error
}

Vue.use(BootstrapVue)

Vue.config.productionTip = false

/* eslint-disable no-new */
window.vm = new Vue({
  el: '#app',
  router,
  template: '<App/>',
  data: {
    user: null
  },
  components: {
    App
  }
})



// WEBPACK FOOTER //
// ./src/main.js